import { render, staticRenderFns } from "./GvsHomePage.vue?vue&type=template&id=b2371d0e&scoped=true&"
import script from "./GvsHomePage.vue?vue&type=script&lang=js&"
export * from "./GvsHomePage.vue?vue&type=script&lang=js&"
import style0 from "./GvsHomePage.vue?vue&type=style&index=0&id=b2371d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2371d0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
